import { useState } from 'react';
import { useGetPurchaseOrder } from '@/services/apis/queries/purchase-order/use-get-purchase-order';
import type { PurchaseOrderComment } from '@/types/core/purchase-order/purchase-order-comment';

type UsePurchaseOrderMainCommentsProps = {
  purchaseOrderId: string;
};

export function usePurchaseOrderMainComments({
  purchaseOrderId,
}: UsePurchaseOrderMainCommentsProps) {
  const { data: purchaseOrder } = useGetPurchaseOrder(purchaseOrderId);

  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedComment, setSelectedComment] =
    useState<PurchaseOrderComment | null>(null);

  const openCreateDialog = () => {
    setOpenCreate(true);
  };

  const openEditDialog = (comment: PurchaseOrderComment) => {
    setSelectedComment(comment);
    setOpenEdit(true);
  };

  const openDeleteDialog = (comment: PurchaseOrderComment) => {
    setSelectedComment(comment);
    setOpenDelete(true);
  };

  return {
    purchaseOrder,
    openCreate,
    setOpenCreate,
    openEdit,
    setOpenEdit,
    openDelete,
    setOpenDelete,
    selectedComment,
    openCreateDialog,
    openEditDialog,
    openDeleteDialog,
  };
}
